
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/faqs",
      function () {
        return require("private-next-pages/about/faqs/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/faqs"])
      });
    }
  